import Badge from './Badge';

export default {
  id: 'radial_8',
  title: 'Radial_8',
  colors: 3,
  premium: true,
  BadgeComponentStateless: Badge
};
